import React, { cloneElement } from 'react';
import classNames from 'classnames';
import Icon from '../../../design-system/icon.jsx';
import { formatCents } from '../../../../utils/money';
import { Quantity } from '../quantity.jsx';

export const CartItem = ({
  checkboxSwitcher,
  discountPrice,
  finalPrice,
  flavor,
  image,
  itemQuantity,
  itemUrl,
  productTitle,
  variantTitle,
  isQuantityDisabled,
  onAddItem,
  onDecreaseQuantity,
  onIncreaseQuantity,
  onRemoveItem
}) => (
  <div className="cart-popup__item" data-testid="cart-popup-item">
    <div className="cart-popup__item-card">
      <div className="cart-popup__item-img">
        <a {...(itemUrl ? { href: itemUrl } : {})}>
          <img className="lazyload" data-src={image} alt={productTitle} />
        </a>
      </div>
      <div className="cart-popup__item-content">
        <div className="cart-popup__item-info">
          <div className="cart-popup__item-heading">
            <p className="cart-popup__item-product"><b>{productTitle}</b></p>
            {variantTitle && (
              <p className="cart-popup__item-variant">{variantTitle}
                {flavor && (
                  <span>
                    {' '} / {flavor}
                  </span>
                )}
              </p>
            )}
          </div>
          {onRemoveItem && (
            <div className="cart-popup__item-remove-icon" onClick={onRemoveItem}>
              <Icon type="trash" />
            </div>
          )}
          {onAddItem && (
            <div
              className="btn btn--primary btn--rounded cart-popup__item-add-to-cart-btn"
              onClick={onAddItem}
            >
              <span>Add</span>
            </div>
          )}
        </div>
        <div className={classNames('cart-popup__item-quantity-and-price-content', {
          'cart-popup__item-price-content--with-offset': isQuantityDisabled
        })}>
          {itemQuantity && !isQuantityDisabled && (
            <Quantity
              amount={itemQuantity}
              className="cart-popup__item-quantity"
              onDecreaseQuantity={onDecreaseQuantity}
              onIncreaseQuantity={onIncreaseQuantity}
            />
          )}
          <div className='cart-popup__item-price-content'>
            {Boolean(discountPrice) && (
              <p className="cart-popup__item-price cart-popup__item-price--discount">
                {formatCents(discountPrice)}
              </p>
            )}
            <p className={classNames('cart-popup__item-price', {
              'cart-popup__item-price--regular': Boolean(discountPrice)
            })}><b>{formatCents(finalPrice)}</b></p>
          </div>
        </div>
        {checkboxSwitcher && cloneElement(checkboxSwitcher, {
          className: 'cart-popup__item-checkbox-switcher'
        })}
      </div>
    </div>
  </div>
);
